import React from "react";

/**
 * @component EditMultipleIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <EditMultipleIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const EditMultipleIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="EditMultipleIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M17.83 11l1.41 1.41-7.125 7.125a.997.997 0 01-1.493-1.316l.083-.094L17.83 11zM10 13a1 1 0 01.117 1.993L10 15H4a1 1 0 01-.117-1.993L4 13h6zm10.83-5l1.41 1.41-1.83 1.83L19 9.83 20.83 8zM14 9a1 1 0 01.117 1.993L14 11H4a1 1 0 01-.117-1.993L4 9h10zm3-4a1 1 0 01.117 1.993L17 7H4a1 1 0 01-.117-1.993L4 5h13z"
        fillRule="evenodd"
      />
    </svg>
  )
);
EditMultipleIcon.displayName = "EditMultipleIcon";
export default EditMultipleIcon;
